import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const Container = styled.div`
  margin-top: ${props => (props.isMobile ? '23px' : '35px')};
  padding-right: 1rem;
  padding-left: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const MainText = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: ${props => (props.isMobile ? '1.4rem' : '1.5rem')};
  color: ${props => props.color};
  text-align: center;
  ${props => (props.maxWidth ? `max-width: ${props.maxWidth}px` : null)};
`

const SubText = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  color: ${STYLE_CONSTANTS.colors.text.subtleGray};
  line-height: ${props => (props.isMobile ? '1.25rem' : '1.5625rem')};
  font-size: ${props => (props.isMobile ? '1rem' : '1.125rem')};
  margin-top: ${props => (props.isMobile ? '7px' : '14px')};
  ${props => (props.maxWidth ? `max-width: ${props.maxWidth}px` : null)};
  text-align: center;
  max-width: 420px;
`

@inject(all => ({
  isMobile: all.store.ui.isMobile
}))
@observer
class SectionHeader extends Component {
  render() {
    const { title, text, isMobile, maxWidth, color } = this.props
    return (
      <Container isMobile={isMobile}>
        {title ? (
          <MainText maxWidth={maxWidth} isMobile={isMobile} color={color}>
            {title}
          </MainText>
        ) : null}
        {text ? (
          <SubText maxWidth={maxWidth} isMobile={isMobile}>
            {text}
          </SubText>
        ) : null}
      </Container>
    )
  }
}

SectionHeader.defaultProps = {
  title: null,
  text: null,
  maxWidth: null,
  color: STYLE_CONSTANTS.colors.ui.headerGray
}

SectionHeader.propTypes = {
  title: PropTypes.string,
  maxWidth: PropTypes.number,
  text: PropTypes.string,
  color: PropTypes.string
}

export default SectionHeader
